import { Complaint } from '../Complaint'
import { awardType } from '../../strings/types'
import { formDataForRequestAwards } from '../../utilities/'
import { formSchema } from './schema'
import { grantContractFraud } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class GrantContractFraudComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'grant_contract_fraud'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.grantcontractfraud.confirmation
  }

  /*
   * Combine the GCF unique data with the common complaint data.
   */
  formatComplaintForRequest(formData) {
    // Process the data unique to this complaint.
    const {
      allegation,
      allegation_other,
      business_unit,
      hhs_program_detail,
      office_of_secretary
    } = formData

    const detail = {
      allegation,
      allegation_other,
      business_unit,
      contracts: formDataForRequestAwards(formData, awardType.contract),
      grants: formDataForRequestAwards(formData, awardType.grant),
      hhs_program_detail,
      office_of_secretary
    }

    // Return the combined unique data and common data.
    return this.formatCommonComplaintFormData(formData, detail)
  }
}

export default withRecaptcha(
  withBackButtonProtection(
    withDocTitle(GrantContractFraudComplaint, grantContractFraud)
  )
)
